var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 8.16667H18.6666",
    stroke: "#050505",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 12.8333H13.9999",
    stroke: "#050505",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 25.0833V24.5C15.1667 21.2002 15.1667 19.5503 16.1919 18.5251C17.217 17.5 18.8669 17.5 22.1667 17.5H22.7501M23.3334 15.5669V11.6667C23.3334 7.26688 23.3334 5.067 21.9665 3.70016C20.5998 2.33333 18.3998 2.33333 14.0001 2.33333C9.60031 2.33333 7.40042 2.33333 6.03358 3.70016C4.66675 5.06699 4.66675 7.26688 4.66675 11.6667V16.9682C4.66675 20.7541 4.66675 22.647 5.7005 23.9291C5.90934 24.1881 6.14528 24.424 6.4043 24.6329C7.68644 25.6667 9.57937 25.6667 13.3652 25.6667C14.1884 25.6667 14.5999 25.6667 14.9768 25.5337C15.0552 25.506 15.132 25.4742 15.207 25.4383C15.5676 25.2658 15.8586 24.9748 16.4406 24.3928L21.9665 18.8669C22.641 18.1924 22.9782 17.8552 23.1558 17.4264C23.3334 16.9976 23.3334 16.5207 23.3334 15.5669Z",
    stroke: "#050505",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalFeedback);
export default __webpack_public_path__ + "static/media/Total_feedback.e65c5087a91a308a849f42de6da5d6cd.svg";
export { ForwardRef as ReactComponent };